<script>
import LogDetailsMixin from './log-details.mixin.js'
import capitalize from 'lodash/capitalize'

const underscoreRE = /[_-]/g

export default {
  name: 'ClientLogDetails',
  mixins: [LogDetailsMixin],
  computed: {
    changedMerchantsList() {
      const { merchants } = this.metadata

      if (merchants) {
        return this.metadata.merchants.map(m => m.name)
      }

      return []
    },
    feedsNames() {
      const { catalogue } = this.metadata

      if (!catalogue) {
        return '—'
      }

      const { feeds } = catalogue

      if (feeds.length) {
        return feeds
          .map(f => f.name)
          .join(', ')
      }

      return '—'
    },
    changedPropNames() {
      const { changeset } = this.metadata

      if (!changeset) {
        return []
      }

      return Object
        .keys(changeset)
        .map(name => capitalize(name.replace(underscoreRE, ' ')))
    },
    changedPropValues() {
      const { changeset } = this.metadata

      if (!changeset) {
        return []
      }

      const values = []

      for (const key in changeset) {
        if (changeset.hasOwnProperty(key)) {
          values.push(changeset[key])
        }
      }

      return values
    },
  },
}
</script>

<template>
  <expanded-row :columns="columns">
    <template
      v-if="
        action === 'action_create_new_client' ||
          action === 'action_delete_client'
      "
    >
      <div slot="expanded-row-cell-1">
        <div :class="$style.subrow">
          Client Name
        </div>
        <div :class="$style.subrow">
          Aggregator Feed
        </div>
      </div>

      <div slot="expanded-row-cell-2">
        <div :class="$style.subrow">
          {{ metadata.name }}
        </div>
        <div :class="$style.subrow">
          {{ feedsNames }}
        </div>
      </div>
    </template>

    <template v-else-if=" action === 'action_update_client'">
      <div slot="expanded-row-cell-1">
        <div :class="$style.subrow">
          Client Name
        </div>
        <div
          v-for="name in changedPropNames"
          :key="name"
          :class="$style.subrow"
        >
          {{ name }}
        </div>
      </div>

      <div slot="expanded-row-cell-2">
        <div :class="$style.subrow">
          {{ metadata.name }}
        </div>
        <div
          v-for="(value, index) in changedPropValues"
          :key="index"
          :class="$style.subrow"
        >
          {{ value }}
        </div>
      </div>
    </template>

    <template v-else-if="action === 'action_link_new_merchants'">
      <div slot="expanded-row-cell-1">
        <div :class="$style.subrow">
          Client Name
        </div>
        <div :class="$style.subrow">
          Linked Global Merchants - {{ changedMerchantsList.length }}
        </div>
      </div>

      <div slot="expanded-row-cell-2">
        <div :class="$style.subrow">
          {{ metadata.name }}
        </div>
        <div :class="$style.subrow">
          {{ changedMerchantsList.join(', ') }}
        </div>
      </div>
    </template>

    <template v-else-if="action === 'action_unlink_merchants'">
      <div slot="expanded-row-cell-1">
        <div :class="$style.subrow">
          Client Name
        </div>
        <div :class="$style.subrow">
          Unlinked Global Merchants - {{ changedMerchantsList.length }}
        </div>
      </div>

      <div slot="expanded-row-cell-2">
        <div :class="$style.subrow">
          {{ metadata.name }}
        </div>
        <div :class="$style.subrow">
          {{ changedMerchantsList.join(', ') }}
        </div>
      </div>
    </template>
  </expanded-row>
</template>

<style lang="scss" module>
  .subrow {
    margin-bottom: 20px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
</style>
